import { format } from 'date-fns';
import type { DeliveryVoucherFilters } from 'hooks/store/delivery-vouchers';
import type { FormSchema } from './form-schema';

const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');

export const createFilters = (formData: FormSchema): DeliveryVoucherFilters => {
  const { emissionDate, deliveryDate, ...filters } = formData;

  return {
    ...filters,
    ...(emissionDate?.from && {
      emissionDateFrom: formatDate(emissionDate.from),
    }),
    ...(emissionDate?.to && {
      emissionDateTo: formatDate(emissionDate.to),
    }),
    ...(deliveryDate && { deliveryDate: formatDate(deliveryDate) }),
  };
};
